import type { OperatorSelectorProps } from 'react-querybuilder';
import { ConditionValueSelector } from 'src/components/ConditionsBuilder';
import { isFlagField } from 'src/graphql/entities/custom-view/custom-view-config/operators';

// rules keep the whole field object in `field` (typed as a string by react-querybuilder),
// so query-builder's `fieldData` lookup misses it and the field itself is checked instead
export const CustomViewOperatorSelector = (props: OperatorSelectorProps) =>
  isFlagField(props.field) ? null : <ConditionValueSelector {...props} />;
